const mainFont = ['Open Sans', 'Helvetica Neue', 'Helvetica', 'sans-serif'];
const titleFont = ['Roboto Condensed', 'Helvetica Neue', 'Helvetica', 'sans-serif'];

const almostBlack = '#333333';
const highlightGrey = '#888888';
const tmdBlue = '#374567';
const buttonBlue = '#198BF1';

const stdBoxShadow = '-3px -3px 3px 0 rgba(0,0,0,0.19), 3px 0 3px 0 rgba(0,0,0,0.19), 0 3px 3px 0 rgba(0,0,0,0.23)';
const headerHeight = 60;

// const vFastTransition = 'all 0.25s';
const stdTransition = 'all 0.75s';
const fastTransition = 'all 0.25s';
const slowTransition = 'all 1.5s';

export default {
  mainFont,
  titleFont,
  almostBlack,
  highlightGrey,
  tmdBlue,
  buttonBlue,
  stdBoxShadow,
  headerHeight,
  stdTransition,
  fastTransition,
  slowTransition,
};



// WEBPACK FOOTER //
// ./src/components/StyleUtils.js